const IS_UAT_BUILD = (process.env.PUBLIC_URL || '').includes('binhxapxam-uat');

// Production keeps every existing key for backward compatibility. The UAT
// build shares sawce.org's origin, so it must not reuse production state.
export function storageKey(key) {
  return IS_UAT_BUILD ? `xapxam-uat:${key}` : key;
}

export { IS_UAT_BUILD };
